import * as CookieConsent from "vanilla-cookieconsent";

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
CookieConsent.run({

  categories: {
    necessary: {
      enabled: true,  // this category is enabled by default
      readOnly: true  // this category cannot be disabled
    },
    analytics: {
      enabled: true
    }
  },

  guiOptions: {
    consentModal: {
      layout: 'cloud',
      position: 'bottom left',
      flipButtons: false,
      equalWeightButtons: true
    },
    preferencesModal: {
      layout: 'box',
      // position: 'left right',
      flipButtons: false,
      equalWeightButtons: true
    }
  },

  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'Why we use cookies',
          description: 'We use cookies to ensure proper functioning of our site and to enhance your experience. Necessary cookies are essential for basic operations like navigation and security, while statistic cookies anonymously gather data to help us understand visitor interactions and improve our site.',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage Individual preferences'
        },
        preferencesModal: {
          title: 'Manage cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Accept current selection',
          closeIconLabel: 'Close modal',
          sections: [
            {
              title: 'Why we use cookies',
              description: 'We use cookies to ensure proper functioning of our site and to enhance your experience. Necessary cookies are essential for basic operations like navigation and security, while statistic cookies anonymously gather data to help us understand visitor interactions and improve our site.'
            },
            {
              title: 'Strictly Necessary cookies',
              description: 'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',

              //this field will generate a toggle linked to the 'necessary' category
              linkedCategory: 'necessary',
              cookieTable: {
                caption: 'Cookie table',
                headers: {
                  name: 'Cookie',
                  domain: 'Domain',
                  desc: 'Description',
                  country: 'Country',
                },
                body: [
                  {
                    name: '_blackbusinesslistings_rails_session',
                    domain: location.hostname,
                    desc: 'Used to keep track of state for users that interact with the website. E.g. the currently logged in user and preferences.',
                    country: 'Ireland',
                  },
                  {
                    name: '__cf_bm',
                    domain: 'CloudFlare',
                    desc: 'Cloudflare places the cookie on end-user devices that access customer sites protected by Bot Management or Bot Fight Mode.',
                    country: 'United States',
                  },
                  {
                    name: 'JSESSIONID',
                    domain: 'JavaServer Pages Technologies',
                    desc: 'Used to maintain an anonymous user session by the server in Java™ 2 Platform Enterprise Edition web applications. It is a necessary cookie that expires at the end of a session.',
                  },
                ]
              }
            },
            {
              title: 'Performance and Analytics',
              description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
              linkedCategory: 'analytics',
              cookieTable: {
                caption: 'Cookie table',
                headers: {
                  name: 'Cookie',
                  domain: 'Domain',
                  desc: 'Description',
                  country: 'Country',
                },
                body: [
                  {
                    name: 'ahoy_visitor',
                    domain: location.hostname,
                    desc: 'Used for monitoring the usage and performance of the website.',
                    country: 'United States',
                  },
                  {
                    name: 'ahoy_visit',
                    domain: location.hostname,
                    desc: 'Used for monitoring the usage and performance of the website.',
                    country: 'Ireland',
                  },
                ]
              }
            },
            {
              title: 'More information',
              description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
            }
          ]
        }
      }
    }
  }
});